<template>
<div class="cookie-banner-component">
  <section>
    <span>
      <header>
        <h2>We Value Your Privacy</h2>
      </header>

      <article>
        <p>
          This website uses cookies and other data on your device to measure
          site performance, display relevant promotions and improve your
          experience with Respondent.
          <a
            :href="cookiePolicyUrl"
            target="_blank"
            >Cookie Policy</a
          >.
        </p>
      </article>
    </span>

    <footer>
      <h3>How would you like to handle non-essential cookies?</h3>

      <span class="consent-actions">
        <button
          class="btn btn-primary"
          @click="onManageConsent"
        >
          Manage / Decline
        </button>

        <button
          class="btn btn-primary"
          @click="onAcceptAll"
        >
          Accept all
        </button>
      </span>
    </footer>
  </section>
</div>
</template>

<script>
// TODO add URL into config
const cookiePolicyUrl = 'https://www.respondent.io/privacy-policy';

export default {
  data() {
    return {
      cookiePolicyUrl,
    };
  },
  methods: {
    onManageConsent() {
      this.$emit('onManageConsent');
    },
    onAcceptAll() {
      this.$emit('onAcceptAll');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../legacy/scss/lib';

.cookie-banner-component {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;

  width: 100%;
  min-width: 320px;

  background: rgba(0, 0, 0, 0.87);
  color: #fff;
  padding: 16px;

  @include slideInFromBottom();

  h2,
  h3,
  p {
    margin: 0;
  }

  h2 {
    @include typography-base(
      $color: #fff,
      $font-size: 16px,
      $font-weight: 600,
      $letter-spacing: 0.5px
    );
    // Theme styles within different applications are not applied the same
    // so usage of rem units varies between applications
    // TODO remove hardcoded px units after global styles have parity
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
  }

  h3 {
    @include typography-base($color: #fff, $font-weight: 500, $letter-spacing: 0.1px);
    // Theme styles within different applications are not applied the same
    // so usage of rem units varies between applications
    // TODO remove hardcoded px units after global styles have parity
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0;
  }

  a,
  p {
    @include typography-base($color: #fff, $letter-spacing: 0.25px);
    // Theme styles within different applications are not applied the same
    // so usage of rem units varies between applications
    // TODO remove hardcoded px units after global styles have parity
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.25px;
  }

  a {
    text-decoration-line: underline;
  }

  // TODO remove after global styles have parity
  .btn.btn-primary {
    border: 0;
  }

  section {
    @include flex-stack();

    @include media-md-up() {
      @include flex-base($justify-content: center, $gap: 24px);
    }

    & > span,
    & > footer,
    .consent-actions {
      @include flex-stack($gap: 8px);
    }

    @include media-md-up() {
      .consent-actions {
        @include flex-base($justify-content: flex-end, $gap: 8px);
        min-width: 288px;
      }
    }

    @include media-lg-up() {
      // Constrain the width and center the content on larger viewports
      width: 1200px;

      footer h3 {
        white-space: nowrap;
      }
    }
  }

  // Copy of button styles from the researcher application
  // for consistency and reuse of cookie banner artifacts
  // TODO create button mixin
  .btn-primary {
    cursor: pointer;
    min-width: 34px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    display: inline-block;
    user-select: none;
    background-image: none;
    touch-action: manipulation;
    margin-bottom: 0;
    padding: 6px 12px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;

    color: #fff;
    text-transform: none;
    background-color: #0077d5;
    border: 1px solid #0077d5;
    border-radius: 4px;
  }
}
</style>
